/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HpRespHeroModule_homepage$ref: FragmentReference;
export type HpRespHeroModule_homepage = {|
  +heroModule: ?{|
    +title?: ?string,
    +items?: ?$ReadOnlyArray<?{|
      +cmsId: ?number,
      +link: ?string,
      +imageUrl: ?string,
      +title: ?string,
      +contemporaryTrackingString: ?string,
    |}>,
  |},
  +$refType: HpRespHeroModule_homepage$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespHeroModule_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "heroModule",
      "name": "module",
      "storageKey": "module(type:\"hero\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "hero",
          "type": "String!"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "HeroModule",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "Product",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "link",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "imageUrl",
                  "args": null,
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "contemporaryTrackingString",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '845b10c23eb672e08277d8c2bc4b4482';
module.exports = node;
